import { API_BASE } from '@/app/config';

export interface FetchTranscriptionParams {
  action: 'start' | 'stop';
  meeting_id: string;
}

export default async function fetchTranscription(params: FetchTranscriptionParams) {
  await fetch(`${API_BASE}/manage-transcription`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });
}
